"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeactivationParamsManager = void 0;
const resetDeactivationParams_1 = require("../actions/resetDeactivationParams");
const buildDeactivationParams_1 = require("../calculations/buildDeactivationParams");
class DeactivationParamsManager {
    deactivationParams;
    constructor(serviceReferenceManager) {
        this.deactivationParams = (0, buildDeactivationParams_1.buildDeactivationParams)(serviceReferenceManager);
        serviceReferenceManager.onReset(() => {
            (0, resetDeactivationParams_1.resetDeactivationParams)(serviceReferenceManager, this.deactivationParams);
        });
    }
}
exports.DeactivationParamsManager = DeactivationParamsManager;
//# sourceMappingURL=DeactivationParamsManager.js.map